var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIspIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7727 20.5454C16.17 20.5454 20.5454 16.17 20.5454 10.7727C20.5454 5.3754 16.17 1 10.7727 1C5.3754 1 1 5.3754 1 10.7727C1 16.17 5.3754 20.5454 10.7727 20.5454Z",
    stroke: "#6856DB",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7721 20.5454C13.4708 20.5454 15.6585 16.17 15.6585 10.7727C15.6585 5.3754 13.4708 1 10.7721 1C8.07344 1 5.88574 5.3754 5.88574 10.7727C5.88574 16.17 8.07344 20.5454 10.7721 20.5454Z",
    stroke: "#6856DB",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7725 1V20.5454",
    stroke: "#6856DB",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7727 15.6592C16.17 15.6592 20.5454 13.4715 20.5454 10.7728C20.5454 8.07417 16.17 5.88647 10.7727 5.88647C5.3754 5.88647 1 8.07417 1 10.7728C1 13.4715 5.3754 15.6592 10.7727 15.6592Z",
    stroke: "#6856DB",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5454 10.7727H1",
    stroke: "#6856DB",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIspIcon);
export default __webpack_public_path__ + "static/media/IspIcon.13ce0ac4417d767fa9880205e301b601.svg";
export { ForwardRef as ReactComponent };